import { render, staticRenderFns } from "./LandlordProfileDefaultSettings.vue?vue&type=template&id=beef6f2c&"
import script from "./LandlordProfileDefaultSettings.vue?vue&type=script&lang=js&"
export * from "./LandlordProfileDefaultSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports